import React from 'react';
import { getStaticImageUrl } from 'client/utils/image-helpers';

export function WelcomeScreen() {
  return (
    <div className="welcome-screen text-center px-1 py-1 my-1">
      <img
        src={getStaticImageUrl('/img/llm-search.svg')}
        alt=""
        className="error-logo mt-1_25"
        width={204}
        height={120}
      />
      <h2 className="heading-3">Let’s find your perfect car</h2>
    </div>
  );
}
